import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow } from "../../types/BFL/Funktionskontroll";
import { logAndNotifyError } from "../logger";
import { IModuleByggnadsdata, IModuleKylaVattenburet, IModuleLokaler, IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { nameof } from "../../components/Global/Utils";
import { bfv_J9 } from "./BFV_J9";

//todo -> make class?!
export const bfv_J4 = (): IBFModule => {
  const bfName = BFLType.BFV_J4;
  const bfNameOverride = BFLType.BFV_J4;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    let funktionsKontroller: IKontrollResultRow[] = [];
    const dbg = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      const bfJ9 = bfv_J9().getResult(module, bimHandler, roundHandler, globalData);
      const schablonBesparing = bfJ9.data.schablonBesparing;

      //Hittar kylen som betjänar störst gemensam yta
      const roundData = roundHandler.getRoundData();
      const kylSystemMedGemensamBetjäningsyta = roundData?.data.modules.filter(
        (m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet && (m.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta?.find((r) => r.värmeModulId === module.id)
      );
      let kylSystemStörstGemensamYta: IModuleRound | undefined = undefined;
      let ytaProcentSomBetjänasMedKomfortKyla = 0;
      if (kylSystemMedGemensamBetjäningsyta?.length) {
        for (var mi = 0; mi < kylSystemMedGemensamBetjäningsyta?.length; mi++) {
          const modKylSystem = kylSystemMedGemensamBetjäningsyta[mi];
          const gemensamBetjäningsytaAndel = (modKylSystem.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta.find((g) => g.värmeModulId === module.id);
          if (gemensamBetjäningsytaAndel?.ytaAndel && gemensamBetjäningsytaAndel?.ytaAndel > ytaProcentSomBetjänasMedKomfortKyla) {
            kylSystemStörstGemensamYta = modKylSystem;
            ytaProcentSomBetjänasMedKomfortKyla = gemensamBetjäningsytaAndel.ytaAndel;
          }
        }
      }

      if (!kylSystemStörstGemensamYta) {
        return {
          bfName: BFLType.BFV_J4,
          funktionsKontroller: [],
          driftOptimeringar: [],
          note: "",
          error: error,
          debug: {},
          data: { ingenGemensamYta: true },
        };
      }

      //Module and datas
      const moduleKylsystemData: IModuleKylaVattenburet = kylSystemStörstGemensamYta?.data as IModuleKylaVattenburet;
      const byggnadsDataData: IModuleByggnadsdata | undefined = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
      const moduleLokalerData = roundHandler.getRoundData()?.data.modules.find((m) => m?.moduleTypeId === ModuleTypeId.Lokaler)?.data as IModuleLokaler;
      const moduleVärmeSekundärData = module?.data as IModuleVattenburetSekundärsystem;

      //Grundvärden för BFL
      const j4ÄrvärdeFramledning = moduleVärmeSekundärData.framledningArvarde;
      const j4BörvärdeFramledning = moduleVärmeSekundärData.framledningBorvarde;
      const j4DifferensÄrvärde = j4ÄrvärdeFramledning - j4BörvärdeFramledning;

      const j4UtstryrningVärmeventil = moduleVärmeSekundärData.varmeventilUtstyrning / 100;
      const j4ÅrligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();
      const j4VärmehuntensSystemandel = moduleVärmeSekundärData.värmeSystemandel / 100;
      const j4SchablonVärme = schablonBesparing;
      //
      const j4ValdKylform = moduleKylsystemData.kylform;
      const kylformFaktorRow = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j4ValdKylform);

      const j4Kylfaktor = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j4ValdKylform)?.Faktor as number;
      const j4SchablonEnergiKyla = bimHandler.BIM_Schablon_EnergiKyla;
      const j4YtaSomBetjänas = ytaProcentSomBetjänasMedKomfortKyla / 100;

      //TODO: Kan det vara olika resultat på stickprov komfortkyla aktiv?
      const stickProvVärmesystem = moduleLokalerData.stickprov.filter((s) => s.värmeSystem === module?.name);
      const j4KylaAktiv = stickProvVärmesystem[0].komfortKylaAktiv;

      const byggnadArea = byggnadsDataData?.byggnadArea as number;
      const j4NormalEnergianvändning = byggnadArea * j4VärmehuntensSystemandel * j4YtaSomBetjänas * j4SchablonEnergiKyla;

      //=IF(j4KylaAktiv="Ja";(j4DifferensÄrvärde/3)*((j4ÅrligEnergiTransmission*j4VärmehuntensSystemandel*j4SchablonVärme*j4YtaSomBetjänas)-j4NormalEnergianvändning);0)
      const j4Överkonsumption =
        j4KylaAktiv === "Ja" ? (j4DifferensÄrvärde / 3) * (j4ÅrligEnergiTransmission * j4VärmehuntensSystemandel * j4SchablonVärme * j4YtaSomBetjänas) - j4NormalEnergianvändning : 0;

      //'Grunddata IN'!B54='Grunddata IN'!S10
      const pumpIDrift = moduleVärmeSekundärData.pumpstoppKontroll === "PUMP I DRIFT";

      //=IF(AND(pumpIDrift;j4KylaAktiv="Ja");1;0)
      const j4VilkorFörFunktionskontroll = pumpIDrift && j4KylaAktiv === "Ja" ? 1 : 0;

      //=IF(AND(j4VilkorFörFunktionskontroll=1;j4DifferensÄrvärde>=1,5);j4Överkonsumption;0)
      const j4kWhBrutto = j4VilkorFörFunktionskontroll === 1 && j4DifferensÄrvärde >= 1.5 ? j4Överkonsumption : 0;

      const energiSlago = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j4ValdKylform)?.Energislag as string;
      // const kWHperYear = j4kWhBrutto > 0 ? j4kWhBrutto / j4Kylfaktor : "";

      let energiSlag: string;
      let energiSlagAbsorb: string;
      let kWHperYear: number | undefined;
      let kWHperYearAbsorb: number | undefined;

      if (j4ValdKylform === "Absorptionskyla") {
        energiSlag = "Kyla (FJV)";
        energiSlagAbsorb = "Kyla (El)";
        kWHperYear = j4kWhBrutto > 0 && (kylformFaktorRow?.FJV as number) > 0 ? j4kWhBrutto / (kylformFaktorRow?.FJV as number) : undefined;
        kWHperYearAbsorb = j4kWhBrutto > 0 ? j4kWhBrutto / j4Kylfaktor : undefined;
      } else {
        energiSlag = kylformFaktorRow?.Energislag as string;
        energiSlagAbsorb = "";
        kWHperYear = j4kWhBrutto > 0 ? j4kWhBrutto / j4Kylfaktor : undefined;
        kWHperYearAbsorb = undefined;
      }

      const tabell1 = {
        j4ÄrvärdeFramledning,
        j4BörvärdeFramledning,
        j4DifferensÄrvärde,
        j4UtstryrningVärmeventil,
        j4ÅrligEnergiTransmission,
        j4VärmehuntensSystemandel,
        j4SchablonVärme,
        j4ValdKylform,
        j4Kylfaktor,
        j4SchablonEnergiKyla,
        j4YtaSomBetjänas,
        j4KylaAktiv,
        j4NormalEnergianvändning,
        j4Överkonsumption,
        pumpIDrift,
        j4VilkorFörFunktionskontroll,
        j4kWhBrutto,
        kWHperYear,
      };
      dbg["Tabell 1"] = tabell1;

      let messageGenerated = false;

      //=IF(AND(j4VilkorFörFunktionskontroll=1;j4kWhBrutto>1);1;0)
      if (j4VilkorFörFunktionskontroll === 1 && j4kWhBrutto > 1) {
        messageGenerated = true;
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, kWHperYear, energiSlag, { OverrideBFName: bfNameOverride }));
        // funktionsKontroller.push({
        //   index: 1,
        //   kWhs: kWHperYear,
        //   energiSlag: energiSlag,
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ4_FKText1,
        // });
      }

      //Ingen anmärkning - skippa!
      //=IF(AND(j4VilkorFörFunktionskontroll=1;j4kWhBrutto=0);1;0)
      // if (j4VilkorFörFunktionskontroll === 1 && j4kWhBrutto === 0) {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 2,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ4_FKText2,
      //   });
      // }

      //=IF(AND(j4KylaAktiv="Ja";j4VilkorFörFunktionskontroll=0);1;0)
      // if (j4KylaAktiv === "Ja" && j4VilkorFörFunktionskontroll === 0) {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 3,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ4_FKText3,
      //   });
      // }

      //=IF(AND('Grunddata IN'!B54='Grunddata IN'!S10;j4KylaAktiv="Nej");1;0)
      if (pumpIDrift && j4KylaAktiv === "Nej") {
        messageGenerated = true;
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, kWHperYear, energiSlag, { OverrideBFName: bfNameOverride }));
        // funktionsKontroller.push({
        //   index: 4,
        //   kWhs: kWHperYear,
        //   energiSlag: energiSlag,
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ4_FKText4,
        // });
      }

      //=IF(AND(j4KylaAktiv="Nej";'Grunddata IN'!B54='Grunddata IN'!S11);1;0)
      // if (j4KylaAktiv === "Nej" && !pumpIDrift) {
      //   messageGenerated = true;
      //   funktionsKontroller.push({
      //     index: 5,
      //     kWhs: kWHperYear,
      //     energiSlag: energiSlag,
      //     message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ4_FKText5,
      //   });
      // }

      if (messageGenerated && j4ValdKylform === "Absorptionskyla") {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 6, kWHperYearAbsorb, energiSlagAbsorb, { OverrideBFName: bfNameOverride }));
        // funktionsKontroller.push({
        //   index: 6,
        //   kWhs: kWHperYearAbsorb,
        //   energiSlag: energiSlagAbsorb,
        //   message: "",

        // });
      }
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }

    return {
      bfName: BFLType.BFV_J4,
      funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
      driftOptimeringar: [],
      note: "",
      error: error,
      debug: dbg,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfv_J4 };

export default dflt;
